import { Injectable } from '@angular/core';
import { HotToastService, ToastPosition } from '@ngneat/hot-toast';
import { ToastComponent, ToastData } from './toast.component';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  position: ToastPosition;

  constructor(
    private toastService: HotToastService,
    private translate: TranslateService,
  ) {
    this.position = window.innerWidth > 768 ? 'top-right' : 'top-center';
  }

  styles = {
    border: 'none',
    'border-radius': '0px',
    'box-shadow': 'none',
    width: '100%',
    'max-width': '350px',
    'min-width': '280px',
    height: 'fit-content',
    'background-color': 'transparent',
    padding: '0px',
    margin: '10px',
    color: '#000',
  };

  toast(
    message: string,
    type: ToastData['type'] = 'info',
    options?: {
      translate?: boolean;
      params?: any;
    },
  ) {
    const shouldTranslate = options?.translate === true; 
     const finalMessage = shouldTranslate
      ? this.translate.instant(message, options?.params)
      : message;
    this.toastService.show(ToastComponent, {
      autoClose: false,
      style: this.styles,
      data: {
        message: finalMessage,
        type: type,
      },
      position: this.position,
    });
  }
}
